const baseFontSize = 10;

export const pxToRem = (pixels: number) =>
  `${(pixels / baseFontSize) * 1}rem` as unknown as number;
